export const translations = {
  en: {
    nav: {
      demo: "Demo",
      calculator: "Calculator",
      blog: "Blog",
      howItWorks: "How It Works",
      caseStudy: "Case Study",
      about: "About",
      deploy: "Deploy Now",
    },
    hero: {
      overline: "AI Voice Receptionist — Gulf Arabic",
      line1: "Every missed call",
      line2: "is money walking",
      line3: "out the door.",
      sub: "Sawtly answers every call in Najdi, Hijazi, and Gulf dialects — and fluent English — 24/7. It books, reschedules, and confirms while you sleep.",
      ctaPrimary: "Hear It In Action",
      ctaSecondary: "Deploy Your Agent",
      note: "7-day free trial · No Telegram required · 15% revenue share only on recovered bookings",
    },
    marquee: [
      "Najdi Arabic",
      "Hijazi Arabic",
      "Gulf English",
      "24/7 Answering",
      "Instant Booking",
      "WhatsApp Confirmations",
      "Zero Missed Calls",
      "Code-Switching",
    ],
    demo: {
      overline: "Listen to Sawtly in Action",
      title: "Hear our AI receptionist",
      sub: "A real conversation between a caller and our AI — in Arabic and English",
      hint: "This demo uses a salon receptionist script — works for clinics, gyms, real estate, and more",
      agent: "Agent",
      customer: "Customer",
      preview: "Preview Mode",
      previewNote: "Demo audio drops soon — captions auto-play in preview",
      play: "Play",
      pause: "Pause",
    },
    manifesto: {
      overline: "The Manifesto",
      title: "Why we built Sawtly",
      chapters: [
        {
          num: "01",
          title: "Missed calls are silent killers",
          body: "The average Gulf clinic misses 20–40 calls a day. Each one is a patient who books with the competitor that answered.",
        },
        {
          num: "02",
          title: "Dialect is trust",
          body: "A caller in Riyadh hangs up on an Egyptian-accented bot. Sawtly speaks Najdi, Hijazi, and Gulf dialects natively — then switches to English mid-sentence when the caller does.",
        },
        {
          num: "03",
          title: "The phone never sleeps",
          body: "42% of booking calls arrive after working hours. Your AI receptionist answers at 2 AM with the same warmth as 2 PM.",
        },
        {
          num: "04",
          title: "You pay for results",
          body: "Seven days free. After that, 15% of the revenue we recover. If we recover nothing, you pay nothing.",
        },
      ],
    },
    roi: {
      overline: "ROI Calculator",
      title: "What are missed calls costing you?",
      sub: "Localized defaults for your city and industry — the same math as our mini app.",
      city: "City",
      industry: "Industry",
      missed: "Missed Calls Per Day",
      value: "Avg Appointment Value",
      loss: "Estimated Monthly Loss",
      recovery: "Sawtly recovers up to 70%",
      proposalTitle: "Your Proposal",
      dialect: "Dialect",
      currency: "Currency",
      trial: "Trial",
      trialValue: "7 days free",
      after: "After trial",
      afterValue: "15% revenue share",
      cta: "Deploy and Recover This",
      industries: {
        Clinic: "Clinic",
        Restaurant: "Restaurant",
        "Real Estate": "Real Estate",
        Gym: "Gym",
        Salon: "Salon",
        Other: "Other",
      },
      cities: {
        Riyadh: "Riyadh",
        Jeddah: "Jeddah",
        Dubai: "Dubai",
        Doha: "Doha",
        "Kuwait City": "Kuwait City",
        Muscat: "Muscat",
      },
    },
    lead: {
      title: "Deploy your AI receptionist",
      sub: "Fill in your details and we'll set up your voice agent — no Telegram required.",
      name: "Business Name",
      whatsapp: "WhatsApp Number",
      city: "City",
      industry: "Industry",
      missed: "Missed Calls Per Day",
      value: "Avg Appointment Value",
      submit: "Deploy My AI Receptionist",
      sending: "Deploying…",
      successTitle: "You're all set!",
      successBody: "We'll review your details and reach out on WhatsApp within 24 hours.",
      error: "Something went wrong — please try again or message us on Telegram.",
      namePlaceholder: "Al-Noor Dental Clinic",
      whatsappPlaceholder: "+966 5X XXX XXXX",
    },
    telegram: {
      overline: "Optional Channel",
      title: "Prefer Telegram?",
      sub: "Our mini app still works for Telegram users — configure your agent, preview voices, and track deployments.",
      cta: "Try on Telegram (optional)",
    },
    footer: {
      tagline: "AI voice receptionists for the Gulf. Every call answered, in the dialect your customers speak.",
      pages: "Pages",
      contact: "Contact",
      privacy: "Privacy Policy",
      rights: "© 2026 Sawtly. All rights reserved.",
    },
    blog: {
      overline: "The Sawtly Blog",
      title: "Missed calls, dialects & AI",
      sub: "Field notes on voice AI for Gulf businesses.",
      readMore: "Read article",
      minRead: "min read",
      back: "Back to blog",
    },
    common: {
      langToggle: "العربية",
    },
  },
  ar: {
    nav: {
      demo: "التجربة",
      calculator: "الحاسبة",
      blog: "المدونة",
      howItWorks: "كيف يعمل",
      caseStudy: "دراسة حالة",
      about: "من نحن",
      deploy: "انشر الآن",
    },
    hero: {
      overline: "موظف استقبال صوتي بالذكاء الاصطناعي — لهجة خليجية",
      line1: "كل مكالمة فائتة",
      line2: "هي فلوس تمشي",
      line3: "من عندك.",
      sub: "صوتلي يرد على كل مكالمة باللهجة النجدية والحجازية والخليجية — وبالإنجليزي الطلق — على مدار الساعة. [...]",
      ctaPrimary: "اسمعه بنفسك",
      ctaSecondary: "انشر الوكيل الخاص بك",
      note: "تجربة مجانية 7 أيام · بدون تيليجرام · عمولة 15% فقط على الحجوزات المسترجعة",
    },
    marquee: [
      "اللهجة النجدية",
      "اللهجة الحجازية",
      "إنجليزي خليجي",
      "رد على مدار الساعة",
      "حجز فوري",
      "تأكيد عبر واتساب",
      "صفر مكالمات فائتة",
      "تبديل تلقائي بين اللغتين",
    ],
    demo: {
      overline: "اسمع صوتلي أثناء العمل",
      title: "اسمع موظف الاستقبال الذكي",
      sub: "محادثة حقيقية بين متصل وذكائنا الاصطناعي — بالعربي والإنجليزي",
      hint: "هذه التجربة بسيناريو صالون تجميل — وتنفع للعيادات والنوادي والعقارات وغيرها",
      agent: "الوكيل",
      customer: "العميل",
      preview: "وضع المعاينة",
      previewNote: "التسجيل الصوتي يوصل قريبًا — الترجمة تشتغل تلقائيًا للمعاينة",
      play: "تشغيل",
      pause: "إيقاف",
    },
    manifesto: {
      overline: "البيان",
      title: "ليش بنينا صوتلي",
      chapters: [
        {
          num: "01",
          title: "المكالمات الفائتة قاتل صامت",
          body: "العيادة الخليجية العادية تفوّت 20–40 مكالمة يوميًا. كل وحدة منها مريض يحجز عند المنافس اللي رد.",
        },
        {
          num: "02",
          title: "اللهجة هي الثقة",
          body: "المتصل في الرياض يقفل السماعة إذا سمع بوت بلكنة مصرية. صوتلي يتكلم نجدي وحجازي وخليجي بطلاقة — وي�[...]",
        },
        {
          num: "03",
          title: "الجوال ما ينام",
          body: "42% من مكالمات الحجز توصل بعد الدوام. موظف الاستقبال الذكي يرد الساعة 2 الفجر بنفس حفاوة 2 الظهر.",
        },
        {
          num: "04",
          title: "تدفع على النتيجة",
          body: "سبعة أيام مجانًا. بعدها 15% من الإيراد اللي نسترجعه. إذا ما استرجعنا شي، ما تدفع شي.",
        },
      ],
    },
    roi: {
      overline: "حاسبة العائد",
      title: "كم تكلفك المكالمات الفائتة؟",
      sub: "أرقام افتراضية مضبوطة على مدينتك ونشاطك — نفس حسابات الميني آب.",
      city: "المدينة",
      industry: "النشاط",
      missed: "المكالمات الفائتة يوميًا",
      value: "متوسط قيمة الموعد",
      loss: "الخسارة الشهرية التقديرية",
      recovery: "صوتلي يسترجع حتى 70%",
      proposalTitle: "عرضك",
      dialect: "اللهجة",
      currency: "العملة",
      trial: "التجربة",
      trialValue: "7 أيام مجانًا",
      after: "بعد التجربة",
      afterValue: "عمولة 15% من الإيراد",
      cta: "انشر واسترجع هذا المبلغ",
      industries: {
        Clinic: "عيادة",
        Restaurant: "مطعم",
        "Real Estate": "عقارات",
        Gym: "نادي رياضي",
        Salon: "صالون",
        Other: "أخرى",
      },
      cities: {
        Riyadh: "الرياض",
        Jeddah: "جدة",
        Dubai: "دبي",
        Doha: "الدوحة",
        "Kuwait City": "مدينة الكويت",
        Muscat: "مسقط",
      },
    },
    lead: {
      title: "انشر موظف الاستقبال الذكي",
      sub: "عبّ بياناتك وبنجهز وكيلك الصوتي — بدون تيليجرام.",
      name: "اسم النشاط التجاري",
      whatsapp: "رقم الواتساب",
      city: "المدينة",
      industry: "النشاط",
      missed: "المكالمات الفائتة يوميًا",
      value: "متوسط قيمة الموعد",
      submit: "انشر موظف الاستقبال الذكي",
      sending: "جاري النشر…",
      successTitle: "تمام، كل شي جاهز!",
      successBody: "بنراجع بياناتك ونتواصل معك على واتساب خلال 24 ساعة.",
      error: "صار خطأ — حاول مرة ثانية أو راسلنا على تيليجرام.",
      namePlaceholder: "عيادة النور لطب الأسنان",
      whatsappPlaceholder: "+966 5X XXX XXXX",
    },
    telegram: {
      overline: "قناة اختيارية",
      title: "تفضّل تيليجرام؟",
      sub: "الميني آب ما زال شغال لمستخدمي تيليجرام — اضبط وكيلك، جرّب الأصوات، وتابع النشر.",
      cta: "جرّب على تيليجرام (اختياري)",
    },
    footer: {
      tagline: "موظفو استقبال صوتيون بالذكاء الاصطناعي للخليج. كل مكالمة يُرد عليها، باللهجة اللي يتكلمها عملاؤك.[...",
      pages: "الصفحات",
      contact: "التواصل",
      privacy: "سياسة الخصوصية",
      rights: "© 2026 صوتلي. جميع الحقوق محفوظة.",
    },
    blog: {
      overline: "مدونة صوتلي",
      title: "مكالمات فائتة ولهجات وذكاء اصطناعي",
      sub: "ملاحظات ميدانية عن الذكاء الصوتي للأعمال الخليجية.",
      readMore: "اقرأ المقال",
      minRead: "دقيقة قراءة",
      back: "رجوع للمدونة",
    },
    common: {
      langToggle: "English",
    },
  },
};
